import { render, staticRenderFns } from "./ScreeningsUpdateProjectDetails.vue?vue&type=template&id=e170b1ba&scoped=true&"
import script from "./ScreeningsUpdateProjectDetails.vue?vue&type=script&lang=js&"
export * from "./ScreeningsUpdateProjectDetails.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsUpdateProjectDetails.vue?vue&type=style&index=0&id=e170b1ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e170b1ba",
  null
  
)

export default component.exports